import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto } from "@product/scmp-sdk";

import { pageStyle } from "~/components/article/article-render/article-content/standard-styles";
import { Tooltip, tooltipClasses } from "~/components/common/tooltip";
import { ContentShareWidget } from "~/components/content/content-share-widget";

import ShareButtonIcon from "./share-button-icon.svg";

export const Container = styled.div`
  color: #000000;
`;

export const Header = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  margin-block-end: 12px;
`;

const Line = styled.div`
  block-size: 2px;

  background-color: #ffca05;
`;

export const LinePrefix = styled(Line)`
  flex-basis: 64px;

  margin-inline-end: 16px;
`;

export const LineSuffix = styled(Line)`
  flex: 1;

  margin-inline-start: 16px;
`;

export const TimePanel = styled.div`
  padding-inline-start: 16px;
  padding-inline-end: 16px;

  background-color: #ffffff;
`;

const TimePanelText = styled.span`
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 16px;
    line-height: 19px;
  }
`;

export const Time = styled(TimePanelText)``;

export const TheEnd = styled(TimePanelText)`
  margin-inline-start: 16px;
  padding-block: 2px;
  padding-inline: 6px;

  color: #ffffff;

  background-color: #000000;
`;

export const Title = styled.div`
  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;

    font-size: 24px;
    line-height: 30px;
  }
`;

export const Authors = styled.div`
  margin-block-end: 12px;

  color: #999999;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;
  }
`;

export const Content = styled.div`
  ${props => pageStyle(props)}
`;

export const ActionBox = styled.div`
  display: flex;
  align-items: center;

  margin-block-start: -8px;
`;

export const StyledShareButtonIcon = styled(ShareButtonIcon)`
  inline-size: 18px;
  block-size: 16px;
`;

export const StyledContentShareWidget = styled(ContentShareWidget)`
  display: flex;
  button {
    svg {
      block-size: 19px;
    }

    &.facebook {
      & > svg {
        transform: scale(1.9);
      }
    }
    &.twitter {
      & > svg {
        transform: scale(1.7);
      }
    }
    &.copy-link {
      & > svg {
        transform: scale(1.5);
      }
    }
    &.email {
      & > svg {
        transform: scale(1.6);
      }
    }
  }
`;

export const ShareLabel = styled.span`
  margin-inline-end: 5px;

  color: #001246;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;
`;

export const ShareButton = styled.span`
  margin-inline-start: 15px;
  padding-inline-start: 15px;

  cursor: pointer;
  border-inline-start: 1px solid #cccccc;
`;

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    padding: 0;

    border-radius: 5px;

    background-color: #ffffff;

    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),
      0 1px 3px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const ShareBar = styled.div`
  display: flex;
  align-items: center;

  padding-block: 20px 22px;
  padding-inline: 24px;
`;
